import { Box, FormikTextInput } from '@palmetto/palmetto-components';
import { Field, useFormikContext } from 'formik';

import { HVACSystemCategory } from 'types';

import FormSection from '../Forms/FormSection';

const systemsWithHSPF2 = new Set([
  HVACSystemCategory['Dual Fuel Split System'],
  HVACSystemCategory['Heat Pump Split System'],
  HVACSystemCategory['Packaged Heat Pump'],
  HVACSystemCategory['Multi Zone Mini Split'],
  HVACSystemCategory['Single Zone Mini Split'],
]);

export const SystemEfficienciesSection = ({
  index,
  isPackageEditable = true,
}: {
  index: number;
  isPackageEditable?: boolean;
}) => {
  const { values } = useFormikContext<any>();
  const shouldDisplayHSPF2 = systemsWithHSPF2.has(values?.systems[index]?.systemCategory);
  return (
    <FormSection
      title={`${values?.systems[index]?.name || 'Unknown System'} Efficiencies`}
      baseStyle={{ borderWidth: '0' }}
    >
      <Box direction={{ base: 'column', tablet: 'row' }} childGap="xl">
        <Field
          label="SEER2"
          name={`systems.${index}.efficiencies.seer2`}
          id={`systems.${index}.efficiencies.seer2`}
          component={FormikTextInput}
          width="2xl"
          isRequired
          isDisabled={!isPackageEditable}
        />
        {shouldDisplayHSPF2 && (
          <Field
            label="HSPF2"
            name={`systems.${index}.efficiencies.hspf2`}
            id={`systems.${index}.efficiencies.hspf2`}
            component={FormikTextInput}
            width="2xl"
            isRequired={shouldDisplayHSPF2}
            isDisabled={!isPackageEditable}
          />
        )}
      </Box>
    </FormSection>
  );
};
